import { processError } from '../utils/processError';
import api from './index';

const getTimeZone = async () => {
  try {
    const { data } = await api.get(
      "/institutionService/api/Institution/Get-TimeZones"
    );
    return data;
  } catch (e) {
    processError(e);
  }
};


const institutionApi = {
  getTimeZone
};

export default institutionApi;
